import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const OfficeIconMobile = ({
  width = 15,
  height = 15,
  stroke = '#52575C',
  strokeWidth = 0.3,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 15 15"
  >
    <path
      d="M1.86759 6.08702L7.50006 2.14464L13.1325 6.08702C13.3126 6.21291 13.5584 6.16549 13.6812 5.98089C13.8042 5.7961 13.7577 5.54431 13.5777 5.41841L7.72247 1.32043C7.58828 1.22652 7.4117 1.22652 7.27751 1.32043L1.4223 5.41841C1.24223 5.5443 1.19579 5.79608 1.31878 5.98089C1.44158 6.16549 1.68751 6.21291 1.86759 6.08702Z"
      fill="#52575C"
    />
    <path
      d="M13.75 13.3454C13.75 13.1219 13.5732 12.9406 13.3553 12.9406H12.2314V9.88309C12.2314 9.65953 12.0546 9.4785 11.8365 9.4785H8.45956C8.24149 9.4785 8.0649 9.65953 8.0649 9.88309V12.9406H6.93526V9.88309C6.93526 9.65953 6.75867 9.4785 6.5406 9.4785H3.16361C2.94554 9.4785 2.76877 9.65953 2.76877 9.88309V12.9406H1.64481C1.42692 12.9406 1.25015 13.1219 1.25015 13.3454C1.25015 13.5688 1.42692 13.75 1.64481 13.75H13.3552C13.5731 13.75 13.75 13.5688 13.75 13.3454ZM3.55836 12.9408V10.2877H6.14603V12.9406L3.55836 12.9408ZM8.85437 12.9408V10.2877H11.442V12.9406L8.85437 12.9408Z"
      fill="#52575C"
    />
    <path
      d="M9.18855 8.66915C9.40644 8.66915 9.58321 8.48794 9.58321 8.26438V4.80244C9.58321 4.57888 9.40644 4.39786 9.18855 4.39786H5.81137C5.59349 4.39786 5.41672 4.57888 5.41672 4.80244V8.26438C5.41672 8.48794 5.59349 8.66915 5.81137 8.66915H9.18855ZM6.2062 5.20702H8.79386V7.85978H6.2062V5.20702Z"
      fill="#52575C"
    />
    <path
      d="M1.86759 6.08702L7.50006 2.14464L13.1325 6.08702C13.3126 6.21291 13.5584 6.16549 13.6812 5.98089C13.8042 5.7961 13.7577 5.54431 13.5777 5.41841L7.72247 1.32043C7.58828 1.22652 7.4117 1.22652 7.27751 1.32043L1.4223 5.41841C1.24223 5.5443 1.19579 5.79608 1.31878 5.98089C1.44158 6.16549 1.68751 6.21291 1.86759 6.08702Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
    <path
      d="M13.75 13.3454C13.75 13.1219 13.5732 12.9406 13.3553 12.9406H12.2314V9.88309C12.2314 9.65953 12.0546 9.4785 11.8365 9.4785H8.45956C8.24149 9.4785 8.0649 9.65953 8.0649 9.88309V12.9406H6.93526V9.88309C6.93526 9.65953 6.75867 9.4785 6.5406 9.4785H3.16361C2.94554 9.4785 2.76877 9.65953 2.76877 9.88309V12.9406H1.64481C1.42692 12.9406 1.25015 13.1219 1.25015 13.3454C1.25015 13.5688 1.42692 13.75 1.64481 13.75H13.3552C13.5731 13.75 13.75 13.5688 13.75 13.3454ZM3.55836 12.9408V10.2877H6.14603V12.9406L3.55836 12.9408ZM8.85437 12.9408V10.2877H11.442V12.9406L8.85437 12.9408Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
    <path
      d="M9.18855 8.66915C9.40644 8.66915 9.58321 8.48794 9.58321 8.26438V4.80244C9.58321 4.57888 9.40644 4.39786 9.18855 4.39786H5.81137C5.59349 4.39786 5.41672 4.57888 5.41672 4.80244V8.26438C5.41672 8.48794 5.59349 8.66915 5.81137 8.66915H9.18855ZM6.2062 5.20702H8.79386V7.85978H6.2062V5.20702Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);
